import React from 'react'

import classNames from 'classnames'

import AudioPreview from '@components/shared/AudioPreview'
import CoverArt from '@components/shared/CoverArt'
import Product from '@models/Product'
import Score from '@models/Score'
import { useAudioPreview } from '@providers/AudioPreviewProvider'

interface Props {
  score: Score | Product
}
const CoverArtPreviewHandle: React.FC<Props> = ({ score }) => {
  const { isPlaying } = useAudioPreview()
  return (
    <>
      <CoverArt
        url={score.cover_art_url}
        overlay={score.cover_art_directive}
        className={classNames(
          'shadow-none w-[75px] h-[75px] max-w-[75px] max-h-[75px] z-10 bg-gray-light dark:bg-black-bg group-hover:brightness-50',
          {
            'brightness-50': isPlaying(score.id),
          }
        )}
      />
      <div className="absolute inset-0 flex flex-row items-center justify-center z-10">
        <AudioPreview
          id={score.id}
          url={score.audio_preview_url}
          className="text-white text-h2 disabled:text-white not-disabled:hover:scale-105"
        />
      </div>
    </>
  )
}

export default CoverArtPreviewHandle
